import React from "react";

// Invisible anti-spam honeypot. Real users never see or fill this; bots that
// auto-fill every field will populate it and get silently dropped by the API.
export function Honeypot({ value, onChange }) {
  return (
    <div
      aria-hidden="true"
      style={{ position: "absolute", left: "-9999px", top: "-9999px", height: 0, width: 0, overflow: "hidden" }}
    >
      <label htmlFor="company_website">Company website (leave this field empty)</label>
      <input
        id="company_website"
        name="company_website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export default Honeypot;
